import { TemplateItem, TemplateMedia } from '@anm/api/modules/templates';
import { VIDEO_TEMPLATE_ROUTE } from '@anm/constants/routes';
import compactProps from '@anm/helpers/compactProps';
import isMobile from '@anm/helpers/is/isMobile';

import { selectSmallSize } from '../../../store/modules/template/selectors';
import { getAspectParam } from '../TemplateViewModal/helpers';

import { TemplateLinkProps } from './types';

export const MASONRY_ITEM_MARGIN_BOTTOM = 40;

export const getMediaByAspects = (aspects: string, media: TemplateMedia) => {
  const mediaName = aspects
    .split(',')
    .find((aspectName: string) => !!media[aspectName]);

  return mediaName && media[mediaName];
};

export const getBreakpointColumnsObj = () => ({
  default: isMobile() ? 1 : 5,
  1600: 4,
  1366: 3,
  1060: 2,
  860: 1
});

export const getTemplateSize = ({
  meta: { media, defaultTarget }
}: TemplateItem) => {
  const { size } = selectSmallSize(media[defaultTarget].thumb);

  return size;
};

export const getTemplateLink = ({
  filters,
  pageParams,
  templateName,
  route = VIDEO_TEMPLATE_ROUTE
}: TemplateLinkProps) => {
  const { embed, folderId } = pageParams;
  const { aspects = '' } = filters;

  const aspectParam = getAspectParam(aspects);

  const params = compactProps({
    embed,
    folderId,
    pageName: templateName || 'main',
    ...(aspectParam && { aspects: aspectParam })
  });

  const link = { route, params };

  return link;
};
